module.exports = __webpack_public_path__ + "static/media/NIKE X NOTRE_MANUAL FINAL_190719.dd0a5d38.pdf";